<div class="overlay-content">
  <div class="overlay" [class.overlay-fadeout]="isFadingOut">
    <div class="content">
      <div class="header">
        <div class="title">{{'assignment.PREVIOUS_RESULTS' | transloco}}</div>
        <button type="button" class="close" (click)="close()">
          <qai-icon kind="x-close" size="24px" />
        </button>
      </div>
      <div class="body">
        <div class="call">{{ callName }}</div>
        <div class="loading" *ngIf="isLoading">
          <app-three-dots-blinking></app-three-dots-blinking>
        </div>
        <div *ngIf="!isLoading" class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{{'assignment.DATE' | transloco}}</th>
                <th>
                  <div class="th-score">
                    {{'assignment.SCORE' | transloco}}
                    <img
                      src="assets/icons/info-circle-grey.svg"
                      alt=""
                      [matTooltip]="tooltipText"
                      matTooltipClass="score-tooltip"
                      matTooltipPosition="above"
                    />
                  </div>
                </th>
                <th>{{'assignment.RESULTS' | transloco}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let practice of practiceCallResults">
                <td class="nowrap">
                  {{ practice.attemptDate | localeDate:'table-datetime'}}
                </td>
                <td
                  [ngClass]="{
                    'score-green': practice.scoreAchieved >= scoreCriteria,
                    'score-yellow':
                      practice.scoreAchieved >= scoreCriteria - 1 &&
                      practice.scoreAchieved < scoreCriteria,
                    'score-red': practice.scoreAchieved < scoreCriteria - 1,
                    'score-blue':
                      assignmentType === typePractice && scoreCriteria === 0
                  }"
                >
                  <ng-container *ngIf="practice?.isCompliant === false; else scoreBlock">
                    {{ 'assignment.OUTOF_COMPLIANCE' | transloco }}
                  </ng-container>
                  <ng-template #scoreBlock>
                    {{ ((callType === callTypeGuided && callScoreCalcType === calcTypeRatio5pt0min) || callType === callTypeConversational) ? (practice.scoreAchieved | number : '1.1-2') : (practice.scoreAchieved | number : '1.0-2')}} / 5
                  </ng-template>
                </td>
                <td class="nowrap">
                  <button
                    type="button"
                    class="feedback-link"
                    (click)="viewFeedback(practice.practiceCallUuid)"
                  >
                    {{'assignment.VIEW_FEEDBACK' | transloco}}
                    <qai-icon kind="arrow-up-right" size="16px" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
